/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = None

1 = Todo

2 = Contact

3 = ChangeOrder

4 = PurchaseOrder

5 = Sub

6 = InternalUser

7 = IntegrationPartner

8 = Bill

9 = Discussion

10 = File

11 = DailyLog

12 = Schedule

13 = TimeClock

14 = Selection

15 = Survey

16 = Warranty

17 = OwnerInvoice

18 = Rfi

19 = Bid

20 = Estimate

21 = Lead

22 = Job

24 = GlobalUser

27 = Message

28 = SignatureRequest

29 = BidPackage

30 = LeadProposal

31 = SelectionChoice

32 = Allowance

33 = Builder

34 = Folder

35 = Payment

36 = CostCode

37 = CostItem

38 = CreditMemo

39 = Receipt

40 = TodoChecklistItem

41 = User

42 = Subscription

43 = LeadActivity

44 = Specification

45 = Deposit

46 = Integration

47 = BuilderSetup

48 = Rebate

49 = Role

50 = LienWaiver

51 = ClientUpdate

52 = Proposal

53 = Signup

54 = ChatChannel

55 = ProofOfPurchase

56 = SelectionOptions

57 = Task

58 = ProposalFormatItem

59 = Submittal

60 = Approval

61 = Feedback

62 = PlanSet

63 = PlanPage

64 = ScopeOfWork

65 = Worksheet

66 = AiaApprovalWorkflow


 */
export type EntityType = (typeof EntityType)[keyof typeof EntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntityType = {
  None: 0,
  Todo: 1,
  Contact: 2,
  ChangeOrder: 3,
  PurchaseOrder: 4,
  Sub: 5,
  InternalUser: 6,
  IntegrationPartner: 7,
  Bill: 8,
  Discussion: 9,
  File: 10,
  DailyLog: 11,
  Schedule: 12,
  TimeClock: 13,
  Selection: 14,
  Survey: 15,
  Warranty: 16,
  OwnerInvoice: 17,
  Rfi: 18,
  Bid: 19,
  Estimate: 20,
  Lead: 21,
  Job: 22,
  GlobalUser: 24,
  Message: 27,
  SignatureRequest: 28,
  BidPackage: 29,
  LeadProposal: 30,
  SelectionChoice: 31,
  Allowance: 32,
  Builder: 33,
  Folder: 34,
  Payment: 35,
  CostCode: 36,
  CostItem: 37,
  CreditMemo: 38,
  Receipt: 39,
  TodoChecklistItem: 40,
  User: 41,
  Subscription: 42,
  LeadActivity: 43,
  Specification: 44,
  Deposit: 45,
  Integration: 46,
  BuilderSetup: 47,
  Rebate: 48,
  Role: 49,
  LienWaiver: 50,
  ClientUpdate: 51,
  Proposal: 52,
  Signup: 53,
  ChatChannel: 54,
  ProofOfPurchase: 55,
  SelectionOptions: 56,
  Task: 57,
  ProposalFormatItem: 58,
  Submittal: 59,
  Approval: 60,
  Feedback: 61,
  PlanSet: 62,
  PlanPage: 63,
  ScopeOfWork: 64,
  Worksheet: 65,
  AiaApprovalWorkflow: 66,
} as const;
